import { createSlice } from "@reduxjs/toolkit";
import { colors } from "../constants";

const initialState = {
	value: localStorage.getItem("color") || colors[0],
};

export const colorSlice = createSlice({
	name: "color",
	initialState,
	reducers: {
		setColor: (state, { payload }) => {
			state.value = payload;
			localStorage.setItem("color", payload);
		},
	},
});

export const { setColor } = colorSlice.actions;
export default colorSlice.reducer;
